import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../service/translation';

export default class PaginationCount extends Component {

    static propTypes = {
        limit: PropTypes.number,
        total: PropTypes.number,
        EXTKEY: PropTypes.string
    };

    render() {
        const {limit, total, EXTKEY} = this.props;

        return (

            <div className={EXTKEY + '__wrapper--pagination ' + EXTKEY + '__count--pagination'}>
                {limit + ' ' + translate('list_pagination_count') + ' ' + total + ' ' + translate('list_pagination_events_label')}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./React/src/components/PaginationCount.js